exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rasa-chrome-picker {\r\n  margin: 0 3px;\r\n  text-align: center;\r\n  cursor: pointer;\r\n}\r\n.rasa-chrome-picker-disabled {\r\n  cursor: not-allowed !important; /*I hate this*/\r\n}\r\n.rasa-chrome-picker-input {\r\n  display: flex;\r\n}\r\n.rasa-chrome-picker-color-box {\r\n  width: 28px;\r\n  height: 28px;\r\n  margin: 3px 5px !important;\r\n  border: 1px solid rgba(0, 0, 0, .2);\r\n  border-radius: 3px;\r\n  cursor: pointer;\r\n}\r\n.rasa-chrome-picker-hex {\r\n  align-self: center;\r\n  font-size: 1rem;\r\n  line-height: 1.5;\r\n  color: #495057;\r\n  margin: 3px;\r\n}\r\n.block-container {\r\n  position: absolute;\r\n  z-index: 10;\r\n}\r\n.block-container svg {\r\n  display: none;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/chrome-picker/styles.css
// module id = 2301
// module chunks = 29